module.exports = __webpack_public_path__ + "img/5.9fbc1589.jpg";